import React from 'react'
import WordCloud from 'react-d3-cloud'

interface WordCloudProps {
  data: Array<{
    text: string
    value: number
  }>
  totalResponses: number
}

// Define a color palette
const colorPalette = [
  '#dc2626', // Rojo
  '#f97316', // Naranja
  '#eab308', // Amarillo
  '#84cc16', // Verde claro
  '#16a34a', // Verde
  '#0ea5e9', // Azul
  '#8b5cf6', // Púrpura
  '#ec4899', // Rosa
  '#6b7280' // Gris
]

const WordCloudComponent: React.FC<WordCloudProps> = ({ data, totalResponses }) => {
  // Validar datos antes de renderizar
  const validData =
    data?.filter(
      item =>
        item &&
        typeof item.text === 'string' &&
        item.text.trim().length > 0 &&
        typeof item.value === 'number' &&
        item.value > 0
    ) || []

  if (validData.length === 0) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-12 text-center">
        <p className="text-gray-500">No hay palabras para mostrar en esta pregunta.</p>
      </div>
    )
  }

  const fontSizeMapper = (word: { value: number }): number => {
    return Math.log2(word.value) * 8 + 16
  }

  const rotate = (): number => (Math.random() > 0.5 ? 0 : -90)

  return (
    <div className="w-full ">
      <div className="mb-4">
        <p className="font-semibold text-gray-700">Respuestas: {totalResponses}</p>
        <p className="text-sm text-gray-500">
          Se muestran las {validData.length} palabras más frecuentes (excluyendo palabras comunes)
        </p>
      </div>

      <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
        <div className="w-full">
          <WordCloud
            height={300}
            data={validData}
            font="system-ui, -apple-system, sans-serif"
            fontWeight="bold"
            fontSize={fontSizeMapper}
            rotate={rotate}
            padding={2}
            spiral="archimedean"
            fill={(d, i) => colorPalette[i % colorPalette.length]}
            onWordMouseOver={(event, d) => {}}
          />
        </div>
      </div>
    </div>
  )
}

export default WordCloudComponent
